import { render, staticRenderFns } from "./SystemLogConfig.vue?vue&type=template&id=fd8c0b2e&scoped=true&"
import script from "./SystemLogConfig.vue?vue&type=script&lang=js&"
export * from "./SystemLogConfig.vue?vue&type=script&lang=js&"
import style0 from "./SystemLogConfig.vue?vue&type=style&index=0&id=fd8c0b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8c0b2e",
  null
  
)

export default component.exports